"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationKey;
(function (CommunicationKey) {
    CommunicationKey[CommunicationKey["OPEN_BOTTOM"] = 0] = "OPEN_BOTTOM";
    CommunicationKey[CommunicationKey["OPEN_MAIN"] = 1] = "OPEN_MAIN";
    CommunicationKey[CommunicationKey["OPEN_CENTER"] = 2] = "OPEN_CENTER";
    CommunicationKey[CommunicationKey["CLOSE_BOTTOM"] = 3] = "CLOSE_BOTTOM";
    CommunicationKey[CommunicationKey["CLOSE_MAIN"] = 4] = "CLOSE_MAIN";
    CommunicationKey[CommunicationKey["CLOSE_CENTER"] = 5] = "CLOSE_CENTER";
    CommunicationKey[CommunicationKey["SETTINGS_CHANGED"] = 6] = "SETTINGS_CHANGED";
    CommunicationKey[CommunicationKey["PREVIEW"] = 7] = "PREVIEW";
    CommunicationKey[CommunicationKey["DRILL_DOWN_CLICK"] = 8] = "DRILL_DOWN_CLICK";
    CommunicationKey[CommunicationKey["ITEM_SELECTED"] = 9] = "ITEM_SELECTED";
    CommunicationKey[CommunicationKey["WIDGET_EXPORT_DATA"] = 10] = "WIDGET_EXPORT_DATA";
})(CommunicationKey = exports.CommunicationKey || (exports.CommunicationKey = {}));
//# sourceMappingURL=communication-key.js.map